import { useTracking } from '@packages/tracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayForm,
  GTMEventGlycerinFormSubmitClick,
} from '@packages/tracking';

export const useRatingTracking = () => {
  const dispatchTracking = useTracking();

  const label = 'Kundenbewertungen';

  const trackGlycerinButtonClick = ({
    category,
    detail,
  }: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'category' | 'detail'>) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category,
        detail,
        label,
      },
    });
  };

  const trackGlycerinDisplayForm = () => {
    dispatchTracking<GTMEventGlycerinDisplayForm>({
      event: 'DisplayForm',
      DisplayFormData: {
        category: 'Bewertungsformular',
        label,
      },
    });
  };

  const trackGlycerinFormSubmitClick = () => {
    dispatchTracking<GTMEventGlycerinFormSubmitClick>({
      event: 'FormSubmitClick',
      FormSubmitClickData: {
        category: 'Bewertungsformular',
        detail: 'Bewertung abgeben',
        label,
      },
    });
  };

  return {
    trackGlycerinButtonClick,
    trackGlycerinDisplayForm,
    trackGlycerinFormSubmitClick,
  };
};
